const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    } catch {
        return dateString;
    }
};

const formatSession = (session) => {
    if (!session) return '';
    return session === 'AfterNoon' ? 'Afternoon' : session;
};

const ExamSection = ({ examSchedule }) => {
    return (
        <div className="mb-8 print:mb-6">
            <h3 className="text-xl font-bold text-[#0d4f5c] border-b-2 border-[#0d4f5c] pb-2 mb-4">
                Examination Schedule
            </h3>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-[#0d4f5c]">
                    <thead className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a]">
                        <tr>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Date</th>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Paper Code</th>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Paper Title</th>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Session</th>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Timing</th>
                            <th className="py-3 px-4 border border-[#0d4f5c]/50 text-left font-semibold text-white">Signature</th>
                        </tr>
                    </thead>
                    <tbody>
                        {examSchedule.length > 0 ? (
                            examSchedule.map((subject, index) => (
                                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-[#0d4f5c]/5'}>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30">{formatDate(subject.date)}</td>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30 font-medium">{subject.paperCode || 'N/A'}</td>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30">{subject.paperTitle || 'N/A'}</td>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30">{formatSession(subject.session) || 'N/A'}</td>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30">{subject.timing || 'N/A'}</td>
                                    <td className="py-3 px-4 border border-[#0d4f5c]/30">{subject.superintendentSign || ''}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="py-4 text-center text-gray-500">No exam schedule available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ExamSection;